import Fuse from "fuse.js";
import type { ChangeEvent, JSX } from "react";

import Search from "@repo/icons/default/Search";
import { CpsInput } from "corpus";

interface SearchInputProps<T> {
  items: T[];
  onSearch: (items: T[]) => void;
  searchKeys: string[];
  placeholder?: string;
  onChange?: (value: string) => void;
}

export const SearchInput = <T,>({
  items,
  onSearch,
  searchKeys,
  placeholder = "Buscar",
  onChange,
}: SearchInputProps<T>): JSX.Element => {
  const fuseOptions = {
    includeScore: true,
    includeMatches: true,
    threshold: 0.3,
    keys: searchKeys,
  };
  const fuse = new Fuse(items, fuseOptions);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const { value } = e.target;

    if (onChange) onChange(e.target.value);

    if (value.length === 0) {
      onSearch(items);
      return;
    }

    const results = fuse.search(value);
    const itemsResult = results.map((result) => result.item);
    onSearch(itemsResult);
  };

  return (
    <CpsInput IconLeft={Search} onChange={handleInputChange} placeholder={placeholder} />
  );
};
